import { render } from "./CustomReferenceListItem.vue?vue&type=template&id=5d60882c"
import script from "./CustomReferenceListItem.vue?vue&type=script&lang=js"
export * from "./CustomReferenceListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__